// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-change-list{position:absolute;z-index:1000}", "",{"version":3,"sources":["webpack://./resources/js/components/ChangeEmployeeInline.vue"],"names":[],"mappings":"AAEA,kBACI,iBAAA,CACA,YADJ","sourcesContent":["\n\n.user-change-list {\n    position: absolute;\n    z-index: 1000;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
